// Libs
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

// Components & Utils
import MealPlanApi from "../api/MealPlans";
import MenuSelect from "./MenuSelect";
import MealSelect from "./MealSelect";
import MealsToAdd from "./MealsToAdd";
import { useGlobalValue } from "../utils/GlobalState";
import { setIsLoading, setErrors } from "../utils/Actions";

export default function MealPlans(props) {
  // State
  const [, dispatch] = useGlobalValue();
  const [menuValue, setMenuValue] = useState(0);
  const [mealsToAdd, setMealsToAdd] = useState([]);

  // Reset state on date change
  useEffect(() => {
    const reset = () => {
      setMenuValue(0);
      setMealsToAdd([]);
    };
    reset();
  }, [props.date]);

  const addMeals = () => {
    setIsLoading(true, dispatch);
    MealPlanApi.newOnceOff(props.date, mealsToAdd)
      .then(() => {
        setIsLoading(false, dispatch);
        dispatch({
          type: "setRefresh",
          refresh: true
        })
        props.hide();
      })
      .catch(apiError => {
        setIsLoading(false, dispatch);
        setErrors(apiError, dispatch);
      });
  };

  let date = props.date.format("dddd Do MMMM");

  return (
    <Modal show={props.show}>
      <Modal.Header>
        <Modal.Title>Add Meal: {date}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MenuSelect onChange={setMenuValue} date={props.date} />
        <hr />
        <MealSelect
          menuId={menuValue}
          date={props.date}
          onAdd={meal => {
            setMealsToAdd([...mealsToAdd, meal]);
          }}
        />
        <hr />
        <MealsToAdd meals={mealsToAdd} updateMeals={setMealsToAdd} />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.hide}>Cancel</Button>
        <Button variant="success" onClick={() => addMeals()}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
